import React from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';

import Grafik from './components/Grafik';
import Energieende from './components/Energiewende';
import Wärmeplanung from './components/Wärmeplanung';
import Leistungsbausteine from './components/Leistungsbausteine';
import Ansprechpartner from './components/Ansprechpartner';
import Erstanfrage from './components/Erstanfrage';
import Referenzprojekte from './components/Referenzprojekte';
import Downloads from './components/Downloads';
import Footer from './components/Footer';
import Subfooter from './components/Subfooter';

import './index.css';

import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';

import './App.css';

const Layout = () => (
  <>
    <Grafik />
    <div className="global-wrapper">
      <Outlet />
      <Footer />
      <Subfooter />
    </div>
  </>
);

const HomePage = () => (
  <>
    <Energieende />
    <Wärmeplanung />
    <Leistungsbausteine />
    <Ansprechpartner />
    <Erstanfrage />
    <Referenzprojekte />
    <Downloads />
  </>
);

const App: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="impressum" element={<Impressum />} />
        <Route path="datenschutz" element={<Datenschutz />} />
      </Route>
    </Routes>
  );
};

export default App;
